<template>
  <div
    v-loading="true"
    class="uz-root-loading min-h-[calc(100vh-9rem)] w-full"
  />
</template>
